// https://github.com/GuilhemBarboux/groceries/blob/master/app/shared/services/AFPService.js
import Channel from '@/models/Channel';
import Search from '@/models/Search';
import Oauth2 from 'client-oauth2';
import axios from 'axios';

// TODO : Secure that on server side
// CONSTANTS
const CREDENTIALS = {
  username: 'Gobelins-GBarboux',
  password: '740e8018a47d',
};
const TOKEN_KEY = 'afp-token';
// const SEARCH_KEY = 'Recherche';
const V1 = '/v1/api';
const URLS = {
  search: `${V1}/search`,
};

// Clients
const oauth = new Oauth2({
  clientId: 'Gobelins',
  clientSecret: '5812dd69-9558-4b8a-a25a-378053ec825b',
  accessTokenUri: 'https://api.afp.com/oauth/token',
  redirectUri: 'https://api.afp.com/oauth/token',
  scopes: ['read'],
});
const http = axios.create({
  baseURL: 'https://api.afp.com/',
});

// Store module
const api = {
  state: {
    limit: 20,
    token: undefined,
    refreshInterceptor: undefined,
    cache: [],
  },
  getters: {},
  mutations: {
    setLimit(state, limit) {
      state.limit = limit;
    },
    setToken(state, token) {
      state.token = token;
      http.defaults.headers.common.Authorization = `Bearer ${token.accessToken}`;
      localStorage.setItem(TOKEN_KEY, JSON.stringify(state.token.data));
    },
    clearToken(state) {
      state.token = undefined;
      http.defaults.headers.common.Authorization = '';
      localStorage.setItem(TOKEN_KEY, '');
    },
    addCacheRequest(state, config) {
      state.cache.push(config);
    },
    setRefreshTokenInterceptor(state, refreshInterceptor) {
      if (state.refreshInterceptor) {
        http.interceptors.response.eject(state.refreshInterceptor);
      }

      state.refreshInterceptor = http.interceptors.response.use(
        response => response,
        refreshInterceptor,
      );
    },
  },
  actions: {
    authenticateAPI({ state, dispatch, commit }) {
      let currentToken = localStorage.getItem(TOKEN_KEY);

      commit('setRefreshTokenInterceptor', error => dispatch('refreshTokenInterceptor', error));

      if (state.cache.length > 0) {
        currentToken = commit('clearToken');
      }

      if (currentToken) {
        return commit('setToken', oauth.createToken(JSON.parse(currentToken)));
      }

      return oauth.owner.getToken(CREDENTIALS.username, CREDENTIALS.password)
        .then(token => commit('setToken', token));
    },
    refresh({ state, commit }) {
      return state.token.refresh()
        .then(token => commit('setToken', token));
    },
    refreshTokenInterceptor({ state, commit, dispatch }, error) {
      const request = error.config;

      if (error.response.status === 401 && !request.retry) {
        request.retry = true;

        if (state.cache.length === 0) {
          dispatch('refresh')
            .catch(() => dispatch('authenticateAPI'))
            .then(() => state.cache.forEach(cr => cr(true)))
            .catch(() => state.cache.forEach(cr => cr(false)));
        }

        return new Promise((resolve, reject) => {
          commit('addCacheRequest', (isRefresh) => {
            request.headers.Authorization = http.defaults.headers.common.Authorization;
            if (isRefresh) resolve(http(request));
            else reject(error);
          });
        });
      }

      return Promise.reject(error);
    },
    getDocsByResponse(context, response = {}) {
      const data = Object.assign({
        docs: [],
      }, (response.data || {}).response || {});

      return data.docs;
    },
    loadSequencesBySearch({ state, dispatch }, search) {
      const {
        slugs,
        urgency,
        topics,
        update,
        uno,
      } = search instanceof Search ? search : new Search();

      const contains = [
        ...slugs,
        slugs.join(' '),
      ];

      const postData = {
        tz: 'Europe/Paris',
        lang: 'fr',
        sortOrder: 'desc',
        maxRows: state.limit,
        query: {
          and: [
            {
              name: 'product',
              in: [
                'multimedia',
              ],
            },
          ],
        },
      };

      if (slugs.length > 0) {
        postData.query.and.push({
          or: [
            {
              name: 'title',
              contains,
            },
            {
              name: 'slug',
              contains,
            },
          ],
        });
      }

      if (update instanceof Date) {
        postData.dateRange = {
          from: update.toISOString(),
          to: 'now',
        };
      }

      if (urgency) {
        postData.query.and.push({
          name: 'urgency',
          in: [...Array(urgency + 1).keys()],
        });
      }

      if (topics.length > 0) {
        postData.query.and.push({
          name: 'topic',
          in: topics,
        });
      }

      if (uno) {
        postData.query.and.push({
          exclude: [
            {
              name: 'uno',
              contains: [
                uno,
              ],
            },
          ],
        });
      }

      return http.post(URLS.search, postData)
        .then(response => dispatch('getDocsByResponse', response))
        .then(docs => Channel.getSequencesByDocs(docs.reverse()));
    },
    loadChannel({ dispatch }, channel) {
      return dispatch('loadSequencesBySearch', channel.search)
        .then(sequences => new Channel({
          ...channel,
          search: new Search({
            ...channel.search,
            update: new Date(),
          }),
          sequences: [
            ...channel.sequences,
            ...sequences,
          ],
        }));
    },
    /* loadChannelUpdated({ dispatch }, channel) {
      return dispatch('loadSequencesBySearch', channel.search)
        .then(sequences => new Channel({
          ...channel,
          search: new Search({
            ...channel.search,
            update: new Date(),
          }),
          sequences: [
            ...channel.sequences,
            ...sequences,
          ],
        }));
    },
    loadChannelBySearch({ dispatch }, search) {
      return dispatch('loadChannelUpdated', new Channel({
        id: SEARCH_KEY,
        name: SEARCH_KEY,
        search,
      }));
    },
    loadChannelById({ state, dispatch }, channelId) {
      return dispatch('loadChannelUpdated', new Channel({
        id: channelId,
        name: channelId,
        search: state.searchs[channelId],
        editable: !state.searchs[channelId],
      }));
    }, */
  },
};

export default api;



// WEBPACK FOOTER //
// ./src/store/modules/Api.js